import { Observable } from 'rxjs';
import { LoginService } from './../core/services/login.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { GameService } from '../core/services/game.service';
import { EventsService } from '../core/services/events.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  loader = false;

  heMsisdn = '';
  msisdn: any;
  pin: any;
  errorMessage = '';
  pageLogin = false;
  password: any;
  subProducts: any;
  pinSent: boolean;
  invalidMsisdn: boolean;
  invalidPin: boolean;
  invalidToken: boolean;
  invalidApi: boolean;
  tooManyPin: boolean;
  submitedPin: boolean;
  subError = false;
  nocreditError = false;
  subSuccess = false;
  responsePin: any;
  responseLogin: any;
  subsAvailable = false;
  oSAvailable = false;
  osSuccess = false;
  lang: string = 'en';

  tc = false;
  constructor(
    public loginService: LoginService,
    public router: Router,
    private location: Location,
    private gameService: GameService,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
    this.getSubsAvailable();

  }

  getSubsAvailable () {

    this.gameService.getPlayerData().subscribe((response: any) => {
      if (response.responseData.products) {
        let playerSubs = response.responseData.products.find(x => x.searchKey == "SUBSCRIPTION");
        
        if (playerSubs.status != 'ACTIVE') {
          this.subsAvailable = true;
        }

        let playerOS = response.responseData.products.find(x => x.searchKey == "ONE_SHOT");
        
        if (playerOS.status != 'ACTIVE') {
          this.oSAvailable = true;
        }
        
      }
    });
  }
    
  productBuy(searchKey) {
    this.loader = true;
    this.gameService.getPlayerData().subscribe((response: any) => {
      if (response.responseData.isSubscribed) {
        this.subError = true;
        this.loader = false;
      } else {
        this.loginService.productBuy('searchKey').subscribe(data => {
          if (data['responseCode'] == 200) {
            if (data['responseData'].status == 'BILLINGERROR' ||
             data['responseData'].status == 'NOT_BILLED' || data['responseData'].status == 'NOCREDIT') {
              this.subError = true;
              this.loader = false;
            } else {

              this.subSuccess = true;
              this.loader = false;
            }
          } else {
            this.subError = true;
            this.loader = false;
          }
        });
      }
    });
  }


  productBuySubscription() {
    this.events.eventStart({ eventType: 'SUBSCRIPTION', triggerType: 'subscription' });

    this.loader = true;
    if (this.subsAvailable) {
      this.loginService.productBuy('SUBSCRIPTION').subscribe(data => {
        if (data['responseCode'] == 200) {
          if (data['responseData'].status == 'BILLINGERROR') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
            this.subError = true;
            this.loader = false;
          } else if (data['responseData'].status == 'NO_CREDIT' || data['responseData'].status == 'NOCREDIT'){
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
            this.nocreditError = true;
            this.loader = false;
          } else {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data) });
            this.subSuccess = true;
            this.loader = false;
          }
        } else {
          this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
          this.subError = true;
          this.loader = false;
        }
      });
    } else {
      this.subError = true;
      this.loader = false;
    }
  }

  productBuyOs() {
    this.events.eventStart({ eventType: 'SUBSCRIPTION', triggerType: 'oneshot' });
    this.loader = true;
    if (this.oSAvailable) {
      this.loginService.productBuy('ONE_SHOT').subscribe(data => {
        if (data['responseCode'] == 200) {
          if (data['responseData'].status == 'BILLINGERROR') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
            this.subError = true;
            this.loader = false;
          } else if (data['responseData'].status == 'NO_CREDIT' || data['responseData'].status == 'NOCREDIT') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
            this.nocreditError = true;
            this.loader = false;
          } else {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data) });
            this.subSuccess = true;
            this.loader = false;
          }
        } else {
          this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
          this.subError = true;
          this.loader = false;
        }
      });
    } else {
      this.subError = true;
      this.loader = false;
    }
  }

  goBack() {
    this.location.back();
  }
}
